/*
 * IRO-192 — product-card color swatches: hovering a swatch previews that
 * colorway by swapping the card image to the swatch's variant image, reverting
 * when the pointer leaves the swatch row. Delegated at document level so it
 * covers every card surface (collection, recommendations, search, homepage
 * deals). Pointer devices only — touch reports hover:none and would stick.
 */
(function () {
  if (!window.matchMedia || !window.matchMedia("(hover: hover)").matches) return;

  // The image snippet wraps the real <img> in a <div class="product-card__image">,
  // so target the inner <img> (setting src on the wrapper div does nothing).
  function cardImage(card) {
    return card ? card.querySelector(".product-card__image img") : null;
  }

  function restore(card) {
    var img = cardImage(card);
    if (!img || img.dataset.originalSrc === undefined) return;
    if (img.dataset.originalSrc) img.setAttribute("src", img.dataset.originalSrc);
    if (img.dataset.originalSrcset) img.setAttribute("srcset", img.dataset.originalSrcset);
    else img.removeAttribute("srcset");
  }

  document.addEventListener("mouseover", function (e) {
    var swatch = e.target.closest && e.target.closest(".product-card__swatch");
    if (!swatch) return;
    var url = swatch.getAttribute("data-hover-image");
    if (!url) return;
    var img = cardImage(swatch.closest(".product-card"));
    if (!img) return;
    if (img.dataset.originalSrc === undefined) {
      img.dataset.originalSrc = img.getAttribute("src") || "";
      img.dataset.originalSrcset = img.getAttribute("srcset") || "";
    }
    img.setAttribute("srcset", "");
    img.setAttribute("src", url);
  });

  document.addEventListener("mouseout", function (e) {
    var swatch = e.target.closest && e.target.closest(".product-card__swatch");
    if (!swatch) return;
    var row = swatch.closest(".product-card__swatches");
    // Moving to another swatch in the same row: let its mouseover take over.
    if (e.relatedTarget && row && row.contains(e.relatedTarget)) return;
    restore(swatch.closest(".product-card"));
  });
})();
